// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Tabs__tabsContainer__FeIey","myCol":"Tabs__myCol__1Fjoo","myCol2":"Tabs__myCol2__3tbf_","myCol3":"Tabs__myCol3__3LJKa"};